import { trigger, transition, query, style, animate, state } from '@angular/animations';

export const scaleYAnimation = trigger('scaleYAnimation', [
  transition('1 => 0', [
    query('.scaleYTrigger', style({ transform: 'scaleY(0)', opacity: '0', bottom: '0' }), { optional: true }),
    query('.scaleYTrigger', animate('200ms', style({ transform: 'scaleY(1)', opacity: '1', bottom: '100%' })), {
      optional: true
    })
  ]),
  transition('0 => 1', [
    query('.scaleYTrigger', style({ transform: 'scaleY(1)', opacity: '1', bottom: '100%' }), { optional: true }),
    query('.scaleYTrigger', animate('200ms', style({ transform: 'scaleY(0)', opacity: '0', bottom: '0', offset: 1 })), {
      optional: true
    })
  ])
]);
export const collapsingYAnimation = trigger('collapsingYAnimation', [
  transition(':enter', [
    style({height: '0'}),
    animate('200ms ease-in', style({height: '*'}))
  ]),
  transition(':leave', [
    animate('200ms ease-in', style({height: '0'}))
  ])
  // transition('void <=> 1', animate('1000ms ease-in'))
]);
